import CallageChart from './CallageChart';

export default CallageChart;
